import styled from 'styled-components';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export const HeaderBlock = styled(Block)`
    min-height: 6rem;
`;
